import {
  CROSS_CLIENT_DEFAULT_CATEGORIES,
  CROSS_CLIENT_DEFAULT_ICONS,
  CROSS_CLIENT_DEFAULTS,
  CrossClientDefaultCategory,
  FEATURED_CROSS_CLIENT_DEFAULTS,
} from '../../Defaults/crossClientDefaults'
import React, { useState } from 'react'
import classNames from 'classnames'
import './CrossClientLandingDefaults.scss'

export const CrossClientLandingDefaults = () => {
  const [selectedDefaultCategory, setSelectedDefaultCategory] = useState<CrossClientDefaultCategory>('Featured')

  return (
    <>
      <div className='d-flex gap-2'>
        {CROSS_CLIENT_DEFAULT_CATEGORIES.map((key: CrossClientDefaultCategory) => {
          const selected = selectedDefaultCategory === key
          return (
            <div
              key={key}
              className={classNames('d-flex gap-2 px-2 py-1 align-items-center zocks-border-0.5 border border-1 cross-client-category', {
                'zocks-border-color-primary zocks-text-primary': selected,
                'zocks-border-color-gray-300': !selected,
              })}
              onClick={() => setSelectedDefaultCategory(key)}
              role='button'
            >
              <i className={`bi ${CROSS_CLIENT_DEFAULT_ICONS[key]}`} />
              <div className='paragraph-small medium'>{key}</div>
            </div>
          )
        })}
      </div>
      <div className='d-grid gap-3 justify-content-center align-items-start w-100 zocks-mt-2.0 cross-client-grid'>
        {(selectedDefaultCategory === 'Featured' ? FEATURED_CROSS_CLIENT_DEFAULTS : CROSS_CLIENT_DEFAULTS[selectedDefaultCategory]).map((item) => (
          <div key={item.id} className='cross-client-grid-item'>
            <div className='d-flex flex-column align-items-start p-3 zocks-gap-0.75 zocks-border-0.75 border border-1 zocks-border-color-gray-300 zocks-bg-color-gray-100 h-100'>
              <div className='d-flex align-items-center justify-content-center p-2 zocks-text-primary zocks-border-0.5 border border-1 zocks-border-color-gray-200 zocks-bg-color-white'>
                <i className={`bi ${item.icon} fs-5`} />
              </div>
              <div className='d-flex flex-column gap-1 w-100 overflow-hidden'>
                <div className='paragraph-medium medium'>{item.title}</div>
                <div className='paragraph-small'>{item.description}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
